import * as d3 from "d3";
import * as utils from "../utils/utils.js";
import * as lineplot from "../plots/lineplot.js";
import * as heatmap from "../plots/heatmap.js";
import * as columnplot from "../plots/columnplot.js";
import * as barcodeplot from "../plots/barcodeplot.js";


let dy = 15.5;

export function render(data, config, userInput){

    const width = d3.select(`#${config.rootId}`).node().clientWidth;

    const latticeConfig = {
        width: width,
        height: ((width * 0.15) * (d3.max(data.map(e=>e.row)) + 1)),
        padding: config.padding,
        grid: {
            columnSizes: [
                {
                    column: 0,
                    size: 0.15
                },
                {
                    column:1,
                    size:0.35
                },
                {
                    column:2,
                    size:0.3
                },
                {
                    column:3,
                    size:0.2
                }
              
            ]
        }
    };

    LatticeLib.lattice(data, config.rootId, latticeConfig);

    const renderColumnTitles = ()=>{
        let col_1_title = d3.selectAll(".ljs--lattice-plot")
            .filter(d=> d.row == 0 && d.column == 0)
            .append("g")
            .attr("transform", d=>`translate(${d.width/2}, ${-latticeConfig.padding.top - d.padding.top - dy})`)
            .attr("class", "column-title")
            col_1_title.append("svg:image")
                .attr("width", dy)
                .attr("xlink:href", "info.svg")
                .attr("x",-dy/2)
                .attr("y",0)
                .on("mouseover", function(event){
                    d3.select("#context-plots-tooltip")
                        .style("left", (event.pageX - 100) + "px")
                        .style("top", (event.pageY + dy) + "px")
                        .html(`Volcano plot of enriched and depleted genes in the specified comparison.`)
                        .classed("hidden", false)
                }) 
                .on("mouseleave", ()=>{
                    d3.select("#context-plots-tooltip")  
                        .classed("hidden", true)
                })

    col_1_title
            .append("text")
            .attr("y", dy)
            .attr("dy", dy)
            .attr("text-anchor", "middle")
            .html(function(){
                var x = d3.select(this).attr("x");
                var y =  d3.select(this).attr("dy");
                return `<tspan x=${+x} dy=${y}>Gene-Level</tspan>
                <tspan x=${+x} dy=${+y}>Dependency</tspan>
                <tspan class='light' x=${+x} dy=${+y}>${utils.dict().conditionPair[userInput.c]}</tspan>`
                })
                
        
        let col_2 = d3.selectAll(".ljs--lattice-plot")
            .filter(d=> d.row == 0 && d.column == 1)
        let col_2_title = col_2
            .append("g")
            .attr("transform", d=>`translate(${d.width/2}, ${-latticeConfig.padding.top - d.padding.top - dy})`)
            .attr("class", "column-title")

        col_2_title.append("svg:image")
            .attr("width", dy)
            .attr("xlink:href", "info.svg")
            .attr("x",-dy/2)
            .attr("y",0)
            .on("mouseover", function(event){
                d3.select("#context-plots-tooltip")
                .style("left", (event.pageX - 100) + "px")
                .style("top", (event.pageY + dy) + "px")
                .html(` Frequency histograms of enrichment or depletion (z score) for all sgRNAs in gray. sgRNAs targeting indicated genes are shown by colored lines.`)
                .classed("hidden", false)
            }) 
            .on("mouseleave", ()=>{
                d3.select("#context-plots-tooltip")  
                    .classed("hidden", true)
            })

        col_2_title
            .append("text")
            .attr("y", dy)
            .attr("dy", dy)
            .attr("text-anchor", "middle")
            .html(function(){
                var x = d3.select(this).attr("x");
                var y =  d3.select(this).attr("dy");
                return `<tspan x=${+x} dy=${+y}>sgRNA-Level Dependency</tspan>
                <tspan class='light' x=${+x} dy=${+y}>${utils.dict().conditionPair[userInput.c]}</tspan>`
                }) 

        let col_3_title =  d3.selectAll(".ljs--lattice-plot")
            .filter(d=> d.row == 0 && d.column == 2)
            .append("g")
            .attr("transform", d=>`translate(${d.width/2}, ${-latticeConfig.padding.top - d.padding.top - dy})`)
            .attr("class", "column-title")

        col_3_title.append("svg:image")
            .attr("width", dy)
            .attr("xlink:href", "info.svg")
            .attr("x",-dy/2)
            .attr("y",0)
            .on("mouseover", function(event){
                d3.select("#context-plots-tooltip")
                    .style("left", (event.pageX - 100) + "px")
                    .style("top", (event.pageY + dy) + "px")
                    .html(`Performance of individual sgRNAs (z score) across conditions. sgRNAs are colored according to their respective color in the guide-level dependency plot.`)
                    .classed("hidden", false)
            }) 
            .on("mouseleave", ()=>{
                d3.select("#context-plots-tooltip")  
                    .classed("hidden", true)
            })

        col_3_title
            .append("text")
            .attr("y", dy)
            .attr("dy", dy)
            .attr("text-anchor", "middle")
            .html(function(){
                var x = d3.select(this).attr("x");
                var y =  d3.select(this).attr("dy");
                return `<tspan x=${+x} dy=${+y}>sgRNA Performance</tspan>
                <tspan x=${+x} dy=${+y}>Across Conditions</tspan>`
            }) 
        
        let col_4_title = d3.selectAll(".ljs--lattice-plot")
            .filter(d=> d.row == 0 && d.column == 3)
            .append("g")
            .attr("transform", d=>`translate(${d.width/2}, ${-latticeConfig.padding.top - d.padding.top - dy})`)
            .attr("class", "column-title")

        col_4_title.append("svg:image")
            .attr("width", dy)
            .attr("xlink:href", "info.svg")
            .attr("x",-dy/2)
            .attr("y",0)
            .on("mouseover", function(event){
                d3.select("#context-plots-tooltip")
                    .style("left", (event.pageX - 100) + "px")
                    .style("top", (event.pageY + dy) + "px")
                    .html(`RNAseq analysis of transcript detection in cells across in vitro culture conditions: not stimulated (NS) or treated with IFNβ, IFNγ, or TNF for 48 hours.`)
                    .classed("hidden", false)
            }) 
            .on("mouseleave", ()=>{
                d3.select("#context-plots-tooltip")  
                    .classed("hidden", true)
            })
            
        col_4_title.append("text")
            .attr("y", dy)
            .attr("dy", dy)
            .attr("text-anchor", "middle")
            .html(function(){
                var x = d3.select(this).attr("x");
                var y =  d3.select(this).attr("dy");
                return `<tspan x=${+x} dy=${+y}>Gene Expression</tspan>`
                }) 

    }

    const renderRowTitles = ()=>{
        d3.selectAll(".ljs--lattice-plot")
        .each(function(d){
            d3.select(this).select("text").attr("class", "row-title")
            .attr("y", - d.padding.right - d.padding.left)
            .attr("x", (-d.innerHeight/2))
            .attr("transform", "rotate(-90)")
            .attr("text-anchor", "middle")
        })
    }

    const addBorder = ()=>{
        d3.selectAll(".ljs--lattice-plot").select("g").append("rect")
            .attr("x", 0)
            .attr("y", 0)
            .attr("height", d=> d.innerHeight)
            .attr("width", d=> d.innerWidth)
            .attr("class", "plot-border")


            d3.selectAll(".ljs--lattice-plot").classed("active", false)
            .filter(d=>{
                return d._userInput.key == userInput.cl; 
            })
            .classed("active", true)
    }

    renderColumnTitles()
    renderRowTitles()
    addBorder()

    // d3.selectAll(".ljs--lattice-plot")
    // .filter(d=> d.type == "areaplot")
    // .each(function(d){
    //     d.scale.x.nice()
    // })

    barcodeplot.axis();
    columnplot.axis();
    lineplot.axis();
    heatmap.render();

    d3.selectAll(".ljs--lattice-plot").selectAll(".domain").remove()
}


